module.exports = __webpack_public_path__ + "static/media/no_posts.edb61fe5.svg";